import { render, staticRenderFns } from "./RecommendedArticlesComponent.vue?vue&type=template&id=50bef5f1"
import script from "./RecommendedArticlesComponent.vue?vue&type=script&lang=ts"
export * from "./RecommendedArticlesComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports